import { Alert, Popover, Stack, Switch, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { bootstrap, dispose } from '../../../../store/dialer';
import { useAppDispatch } from '../../../../store/hooks';
import DisplayPhoneNumber from '../../../Shared/DisplayPhoneNumber/DisplayPhoneNumber';

interface PopoverProps {
    anchorEl: HTMLElement | null;
    isImpersonated: boolean;
    audioDevicesCount: number;
    phoneNumber: string | undefined;
    isDialerBootstrapped: boolean;
    handleClose: () => void;
}

export const HeaderDialerStatusPopover = ({
    anchorEl,
    isImpersonated,
    audioDevicesCount,
    phoneNumber,
    isDialerBootstrapped,
    handleClose,
}: PopoverProps) => {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();
    const open = Boolean(anchorEl);
    const containerRef = React.useRef<HTMLDivElement>(null);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!event.target.checked) {
            // if User manually turn off virtual phone, destroy the device
            dispatch(dispose());
        } else {
            // if Support staff manually turn on virtual phone while impersonated or,
            // if User manually turn on virtual phone after had turned it off, request twilio config, request twilio config
            dispatch(bootstrap());
        }
    };

    return (
        <Popover
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            PaperProps={{
                sx: {
                    maxWidth: '450px',
                    minWidth: '250px',
                },
                ref: containerRef,
            }}
        >
            <Stack
                direction="column"
                spacing={2}
                padding={2}
                justifyContent="center"
                alignItems="center"
            >
                {isImpersonated && (
                    <Alert severity="warning">
                        <Stack spacing={2}>
                            <Typography variant="body2">
                                You are impersonating another user and as a result their Stay In
                                Contact Virtual Phone has been deactivated for this browser session.
                                You can still enable it below.
                            </Typography>
                            <Stack direction="row" justifyContent="space-between">
                                <Typography>Browser Calling</Typography>
                                <Switch checked={isDialerBootstrapped} onChange={handleChange} />
                            </Stack>
                        </Stack>
                    </Alert>
                )}
                {isDialerBootstrapped && audioDevicesCount < 1 && (
                    <Alert severity="warning">
                        <Typography variant="subtitle2" gutterBottom>
                            Browser calling not active!
                        </Typography>
                        <Typography variant="body2">
                            We could not find any available recording devices. Please ensure you
                            have granted microphone/recording permissions to this website. Also,
                            ensure you have a microphone connected to your computer.
                        </Typography>
                    </Alert>
                )}
                <Typography variant="h6">My StayInContact Number</Typography>
                <Typography>
                    <DisplayPhoneNumber phoneNumber={phoneNumber} />
                </Typography>
            </Stack>
        </Popover>
    );
};

const useStyles = makeStyles()((theme: Theme) => ({}));
